import React, { useEffect, useState } from "react";
import "./DeleteModal.scss";
import CustomButton from "../CustomButton/CustomButton";

const DeleteModal = ({ name, handleDelete, deleting, open, setOpen }) => {
  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <>
      <div className={`delete-modal ${isVisible ? "active" : ""}`}>
        <h1>Delete {name}</h1>
        <p>
          Are you sure you want to <span>DELETE</span> this {name}?
        </p>

        <div className="buttons">
          <CustomButton
            name={"Cancel"}
            color={"danger"}
            type={"button"}
            handleSubmit={() => {
              setOpen(false);
            }}
            disabled={deleting}
          />
          <CustomButton
            name={"Yes"}
            color={"primary"}
            type={"button"}
            handleSubmit={handleDelete}
            disabled={deleting}
            loader={deleting}
          />
        </div>
      </div>
      <div
        onClick={() => {
          setOpen(false);
        }}
        className={`back-delete-modal ${isVisible ? "active" : ""}`}
      ></div>
    </>
  );
};

export default DeleteModal;
